import React,{ useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import coin from '../Assets/coin.png'
import { Cancel } from '@mui/icons-material'
const Layout = ({ balance, setBalance, makingDeposit, setMakingDeposit }) => {
    const navLinks =  [
      {
        id:1,
        title:"Home",
        link:"/",
      },{
        id:2,
        title:"History",
        link:"/activity",
      },{
        id:3,
        title:"Wallet",
        link:"/wallet",
      },{
        id:4,
        title:"Promo",
        link:"/promo",
      },{
        id:5,
        title:"Account",
        link:"/account",
      },
    ]

  const [active, setActive] = useState('')
  const [toggle, setToggle] = useState(false)
  const [depositAmount, setDepositAmount] = useState(0)
  function deposit(){
    setMakingDeposit(true)

  }
  function handleDeposit(){
    setBalance(prev => parseInt(prev) + depositAmount)
  }
  function finishDep(){
    setMakingDeposit(false)
  }
  const [fiat, setFiat] = useState(true)
  return (
    <div className='flex justify-center items-center bg-[#f4f0ef]'>
    <div className='flex flex-col w-[100vw] sm:w-[500px] '>
      {makingDeposit && 
      <div className='flex justify-center items-center'>
        <div className='flex flex-col justify-center absolute top-10 bg-orange-500 p-4 rounded-lg'>
        <div className='flex justify-between'>
        <p className='font-bold text-white text-3xl'>Deposit</p>
        <p onClick={finishDep} className='text-white cursor-pointer font-bold'><Cancel/></p>
        </div>
        
        <div className='m-2 bg-orange-500 grid grid-cols-2 gap-3 py-2 px-3 rounded-lg'>
          <p onClick={()=> setFiat(true)} className={`font-bold text-center cursor-pointer text-white  py-2 ${fiat ? 'bg-green-700' : 'bg-gray-900'} px-4 rounded-lg`}>Fiat</p>
          <p onClick={()=> setFiat(false)} className={`font-bold text-center cursor-pointer text-white  py-2 ${!fiat ? 'bg-green-700' : 'bg-gray-900'} px-4 rounded-lg`}>Crypto</p>
        </div>
        <p className='font-bold p-2 text-green-400'>Deposit in your local currency</p>
        <div className='flex justify-between items-center p-3 bg-gray-700 m-2'>
          <div>
          <p className='font-bold text-green-600'>Min: $5</p>
          <p className='font-bold text-green-600'>Max: $5,000,000</p>
          </div>
          <p style={{ border:'solid 2px green' }} className='px-2 cursor-pointer text-green-500 rounded-lg'>i</p>
        </div>
        <div>
          <input onChange={(e) => setDepositAmount(e.target.value)} value={depositAmount} className='w-[500px] text-green-300 font-bold h-[35px] text- rounded-lg m-2 p-2 bg-gray-800' placeholder='Deposit Amount' type='number'/>
        </div>
        <div style={{ border:'solid 2px green' }} className='m-3 p-4 flex space-x-4 justify-center items-center'>
          <p className='font-bold shadow-md shadow-green-600 p-2 text-green-300 rounded-lg cursor-pointer'>$25</p>
          <p className='font-bold shadow-md shadow-green-600 p-2 text-green-300 rounded-lg cursor-pointer'>$50</p>
          <p className='font-bold shadow-md shadow-green-600 p-2 text-green-300 rounded-lg cursor-pointer'>$100</p>
          <p className='font-bold shadow-md shadow-green-600 p-2 text-green-300 rounded-lg cursor-pointer'>$200</p>
          <p className='font-bold shadow-md shadow-green-600 p-2 text-green-300 rounded-lg cursor-pointer'>$500</p>
          <p className='font-bold shadow-md shadow-green-600 p-2 text-green-300 rounded-lg cursor-pointer'>$1,000</p>
        </div>
        <button  className='m-2 btn-bg self-center font-bold px-4 py-2 rounded-lg text-black'>Deposit</button>
        </div>
      </div>}
    <div className='flex justify-between items-center p-2 bg-orange-500 w-full'>
    <p className=' text-white font-bold text-3xl'>!</p>
        <p className=' text-white font-bold text-4xl'>EC</p>
        {/* <div className="flex justify-center items-center space-x-4 text-green-400 rounded-sm font-bold py-1 px-2 bg-orange-700 text-center"> */}
        {/* <div className='flex space-x-1'>
          <img width={20} src={coin}/>
          <p >${balance}</p>
        </div>
        <p onClick={deposit} className='btn-bg rounded-sm cursor-pointer text-black   p-1 px-2'>Deposit</p>
        </div> */}
        <p className='text-white '>Rules</p>
        <div className='hidden  p-2 space-x-4 font-bold text-green-300'>
        {navLinks.map((link) =>(
          <Link to={link.link} onClick={()=> setActive(link.title)} key={link.id} className={`${ active === link.title ? 'text-white' : 'text-green-300' } font-poppins font-medium cursor-pointer hover:text-white font-poppins`}>
            <p >{link.title}</p>
          </Link>
        ))}
        </div>
    </div>
    <Outlet/>
  </div>
  </div>
  )
}

export default Layout